import requestData, { requestPostViaFormData } from "@/http/request"
export function getOrderInfoRequest({order_id,}){
  return requestData('/return/return/getOrderInfo','POST',{
    order_id,
  })
}
export function uploadImages({files}){
  const data = new FormData()
  data.append('files',files)
  return requestPostViaFormData('/return/return/uploadImages',data)
}
const RETURN_TYPE = {
  REFUND_ONLY: 1,
  RETURNS_AND_REFUNDS:2,
  EXCHANGE_GOODS:3,
}
const FREIGHT_WAY_RESULT = {
  BUYER:1,
  SELLER:2,
  OTHER:3,
}
addReturnOrder.RETURN_TYPE= RETURN_TYPE
addReturnOrder.FREIGHT_WAY_RESULT= FREIGHT_WAY_RESULT
export function addReturnOrder(param) {
  const {
    order_id,
    seller_id,
    return_type,
    freight_way,
    return_reason_id,
    return_remark,
    return_img,
    goods_json,
  } = toString.call(param)==='[object Object]'?param: {}
  return requestData('/return/return/addReturnOrder','POST',{
    order_id,
    seller_id,
    return_type,
    freight_way,
    return_reason_id,
    return_remark,
    return_img,
    goods_json:JSON.stringify(goods_json.map(i=>({
      good_id:i.good_id,
      good_name:i.good_name,
      good_price:i.good_price,
      num:i.num,
      good_remark: i.good_remark
    }))),
  })
}
const ORDER_TYPE_RESULT = {
  INQUIRY: 0,
  SHOP: 8,
}
getReturnOrderList.ORDER_TYPE_RESULT=ORDER_TYPE_RESULT
getReturnOrderList.RETURN_TYPE = RETURN_TYPE
const RETURN_STATUS_RESULT = {
  IN_REVIEW: 0,
  AUDIT_FAILED: -1,
  RETURNING: 1,
  SHIPPED: 2,
  RECEIVED_GOODS: 3,
  RETURN_COMPLETED: 4,
}
getReturnOrderList.RETURN_STATUS_RESULT=RETURN_STATUS_RESULT
export function getReturnOrderList(param) {
  const {
    return_id,
    return_sn,
    plate_number,
    vin,
    brand_name,
    inquiry_id,
    order_sn,
    order_type,
    return_type,
    return_status,
    start_time,
    end_time,
    page=1,
    page_size=10,
  } = toString.call(param)==='[object Object]'?param: {}
  return requestData('/return/return/getReturnOrderList','POST',{
    return_id,
    return_sn,
    plate_number,
    vin,
    brand_name,
    inquiry_id,
    order_sn,
    order_type,
    return_type,
    return_status,
    start_time,
    end_time,
    page,
    page_size,
  })
}
getReturnListRequest.ORDER_TYPE_RESULT = ORDER_TYPE_RESULT
getReturnListRequest.RETURN_TYPE = RETURN_TYPE
getReturnListRequest.RETURN_STATUS_RESULT = RETURN_STATUS_RESULT
export function getReturnListRequest(param){
  const {
    return_id,
    return_sn,
    plate_number,
    vin,
    brand_name,
    inquiry_id,
    order_sn,
    order_type,
    return_type,
    return_status,
    start_time,
    end_time,
    page,
    page_size,
  } = toString.call(param)==='[object Object]'?param: {}
  return requestData('/return/return/getReturnList','POST',{
    return_id,
    return_sn,
    plate_number,
    vin,
    brand_name,
    inquiry_id,
    order_sn,
    order_type,
    return_type,
    return_status,
    start_time,
    end_time,
    page,
    page_size,
  })
}
export function getReturnOrderInfo({ return_id, }){
  return requestData('/return/return/getReturnOrderInfo', 'POST', {
    return_id,
  })
}
updateReturnOrder.RETURN_TYPE= RETURN_TYPE
updateReturnOrder.FREIGHT_WAY_RESULT = FREIGHT_WAY_RESULT
export function updateReturnOrder(param) {
  const {
    return_id,
    order_id,
    seller_id,
    return_type,
    freight_way,
    return_reason_id,
    return_remark,
    return_img,
    goods_json,
  } = toString.call(param)==='[object Object]'?param:{}
  return requestData('/return/return/updateReturnOrder', 'POST', {
    return_id,
    order_id,
    seller_id,
    return_type,
    freight_way,
    return_reason_id,
    return_remark,
    return_img: toString.call(return_img)==='[object Array]'?return_img.join('|'):return_img,
    goods_json:JSON.stringify(goods_json.map(i=>({
      good_id:i.good_id,
      good_name:i.good_name,
      good_price:i.good_price,
      num:i.num,
      good_remark: i.good_remark,
    }))),
  })
}
examineReturnOrder.STATUS_RESULT={
  PASS:1,
  REJECT:2,
}
export function examineReturnOrder(param){
  const {
    return_id,
    status,
    fail_reason,
    address_id,
  } = toString.call(param)==='[object Object]'?param:{}
  return requestData('/return/return/examineReturnOrder','POST', {
    return_id,
    status,
    fail_reason,
    address_id,
  })
}
returnSendGoods.LOGISTICS_TYPE_RESULT={
  BACK:1,
  CHANGE_FOR_NEW:2,
}
export function returnSendGoods(param){
  const {
    return_id,
    logistics_type,
    logistics_sn,
    logistics_company,
    logistics_contact,
    logistics_treight,
    logistics_intro,
  } = toString.call(param)==='[object Object]'?param:{}
  return requestData('/return/return/returnSendGoods','POST',{
    return_id,
    logistics_type,
    logistics_sn,
    logistics_company,
    logistics_contact,
    logistics_treight,
    logistics_intro,
  })
}
returnReceive.RECEIVE_TYPE_RESULT = {
  DEALER:1,
  BUYER:2,
}
export function returnReceive(param){
  const {
    return_id,
    receive_type,
  } = toString.call(param)==='[object Object]'?param:{}
  return requestData('/return/return/returnReceive','POST',{
    return_id,
    receive_type,
  })
}